import Delete from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import "./Portfolio.css";

const StyledCenterCell = styled("div")({
    textAlign: "center",
    fill: "#9e9e9e",
});

const StyledShrinkButton = styled(Button)({
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    margin: 0,
    color: "#9e9e9e",
    "&:hover": {
        backgroundColor: "transparent",
    },
});

const PortfolioPropertyDetail = (props) => {
    const {
        dataPathPrefix,
        disableInputs,
        element,
        elementIndex,
        errors,
        handleBlurValidate,
        handleUpdateArrayElement,
        onDelete,
    } = props;

    return (
        <div>
            <div className={elementIndex === 0 ? "portfolioFlexContainer" : "portfolioFlexContainerWElementIndex"}>
                <BSInput
                    id="propertyId"
                    label={elementIndex === 0 ? "Property ID" : null}
                    errorText="(ex. 98101)"
                    placeholder="Enter property ID"
                    value={element ? element.propertyId : null}
                    error={get(errors, `portfolioProperties.${elementIndex}.propertyId`, null)}
                    onChange={(e) =>
                        handleUpdateArrayElement(
                            dataPathPrefix + ".portfolioProperties",
                            elementIndex,
                            e.target.id,
                            e.target.value
                        )
                    }
                    onBlurValidate={(id, value) => handleBlurValidate("portfolio", id, value)}
                    disabled={disableInputs}
                />
                <StyledCenterCell>
                    {elementIndex > 0 && disableInputs !== true && (
                        <StyledShrinkButton onClick={() => onDelete(elementIndex)}>
                            <Delete />
                        </StyledShrinkButton>
                    )}
                </StyledCenterCell>
            </div>
        </div>
    );
};

export default PortfolioPropertyDetail;
